import toast from "react-hot-toast";
import customFetch from "../hooks/fetchWrapper";

// Create a new bustop
export const createBustop = async (formBody) => {
  return toast.promise(
    customFetch("bustops", {
      method: "POST",
      body: JSON.stringify(formBody),
    }),
    {
      loading: "Creating bustop...",
      success: (data) => `${data.message}`,
      error: "Failed to create bustop",
    }
  );
};

// Update an existing bustop
export const updateBustop = async (formBody) => {
  console.log("🚀 ~ updateBustop ~ formBody:", formBody);
  return toast.promise(
    customFetch(`bustops`, {
      method: "PUT",
      body: JSON.stringify(formBody),
    }),
    {
      loading: "Updating bustop...",
      success: (data) => `${data.message}`,
      error: "Failed to update bustop",
    }
  );
};

// Delete a bustop
export const deleteBustop = async (id) => {
  return toast.promise(
    customFetch(`bustops/${id}`, {
      method: "DELETE",
    })
      .then((response) => {
        // Check if response is already a parsed object
        if (typeof response === "object" && response !== null) {
          return response;
        }

        // If response is not an object, try to parse it
        try {
          return JSON.parse(response);
        } catch (e) {
          // If parsing fails, return a default object
          return { status: true, message: "Delete successful" };
        }
      })
      .then((data) => {
        if (!data.status) {
          throw new Error(data.message || "Delete failed");
        }
        return data;
      }),
    {
      loading: "Deleting bustop...",
      success: (data) => data.message || "Delete successful",
      error: (err) => err.message || "Failed to delete bustop",
    }
  );
};

// Fetch all bustop
export const getAllBustop = async () => {
  try {
    const response = await customFetch("bustops", {
      method: "GET",
    });
    return response;
  } catch (error) {
    console.error("Error fetching bustop:", error);
    throw error;
  }
};

// Fetch all bustop
export const getBustopByRouteId = async (routeId) => {
  try {
    const response = await customFetch(`bustops/route/${routeId}`, {
      method: "GET",
    });
    return response;
  } catch (error) {
    console.error("Error fetching bustop:", error);
    throw error;
  }
};

// Delete all areas
export const deleteAllBustop = async () => {
  return toast.promise(
    customFetch("bustops-delete/bulk-delete", {
      method: "DELETE",
    }).then((data) => {
      if (!data.status) {
        throw new Error(data.message || "Delete all failed");
      }
      return data;
    }),
    {
      loading: "Deleting all bustops...",
      success: (data) => data.message || "All bustops deleted successfully",
      error: (err) => err.message || "Failed to delete all bustops",
    }
  );
};
